export enum B2BAccountRoleEnum {
    VET = 'veterinary',
    REGULAR = 'regular',
}
